import { z } from 'zod';

export const referralStatusSchema = z.enum(['ACTIVE', 'PAUSED']);

export const referralRewardStatusSchema = z.enum([
  'PENDING',
  'COMPLETED',
  'REJECTED_LIMIT',
  'REJECTED_FRAUD',
  'INVALID_CODE',
  'SELF_REFERRAL'
]);

export const referralRewardRecordSchema = z.object({
  inviteeEmail: z.string().nullable().optional(),
  status: referralRewardStatusSchema,
  rewardAmount: z.number(),
  createdAt: z.string().nullable().optional(),
  completedAt: z.string().nullable().optional()
});

export const referralSummarySchema = z.object({
  referralCode: z.string().nullable(),
  shareUrl: z.string().nullable(),
  status: referralStatusSchema,
  rewardAmount: z.number().nullable(),
  totalRewardAmount: z.number().nullable(),
  dailyLimit: z.number().nullable(),
  dailyRewardCount: z.number(),
  remainingDailyRewards: z.number().nullable(),
  totalLimit: z.number().nullable(),
  totalRewardCount: z.number().nullable(),
  remainingTotalRewards: z.number().nullable(),
  successfulCount: z.number().nullable(),
  lastRewardAt: z.string().nullable().optional(),
  recentRewards: referralRewardRecordSchema.array()
});

export const referralActivitySchema = z.object({
  items: referralRewardRecordSchema.array(),
  totalElements: z.number(),
  totalPages: z.number(),
  page: z.number(),
  size: z.number(),
  hasNext: z.boolean(),
  hasPrevious: z.boolean()
});

export type ReferralSummaryResponse = z.infer<typeof referralSummarySchema>;
export type ReferralRewardRecord = z.infer<typeof referralRewardRecordSchema>;
export type ReferralActivityResponse = z.infer<typeof referralActivitySchema>;
